import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { CategoryFilterValue } from '@features/spa/hooks/useSpaEntityFilter';
import { FacilitiesConnected as FacilitiesV1 } from './container';
import { FacilitiesV2 } from './v2';

type FacilitiesVersionProps = {
  categoryId?: CategoryFilterValue;
  language: string;
  isLoading?: boolean;
};

export const FacilitiesVersion: FC<FacilitiesVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2.spa-days');
  if (isV2) return <FacilitiesV2 {...props} />;
  return <FacilitiesV1 {...props} />;
};
